// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class StoreCreditAPI extends MainAPI {
	/**
	* @return Object
	*/
	async getStoreCredit() {
		return API.get(`${ENDPOINTS.GET_STORE_CREDIT}/available`);
	}

	/**
	* @param petId
	* @param chargeDetails
	* @return {object}
	*/
	async chargeStoreCredit(petId,chargeDetails) {
		return API.post(`${ENDPOINTS.POST_STORE_CREDIT}/charge/${petId}`, chargeDetails);
	}
}

export default new StoreCreditAPI();